import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.progressBar = this.element.querySelector('.progress-bar')
    this.statusText = this.element.querySelector('.text-center')
    this.startProgressCheck()

    // Add event listener for Turbo navigation
    document.addEventListener('turbo:before-visit', this.cleanup)
  }

  disconnect() {
    this.cleanup()
    // Remove event listener when controller is disconnected
    document.removeEventListener('turbo:before-visit', this.cleanup)
  }

  // Bind the cleanup method to the controller instance
  cleanup = () => {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }

  startProgressCheck() {
    this.checkProgress()
    this.checkInterval = setInterval(() => {
      this.checkProgress()
    }, 2000)
  }

  async checkProgress() {
    try {
      const response = await fetch('/api/v1/file_imports/status')
      const data = await response.json()
      
      // Check if element still exists in DOM before updating
      if (!this.element.isConnected) {
        this.cleanup()
        return
      }
      
      this.progressBar.style.width = `${data.percentage}%`
      this.progressBar.setAttribute('aria-valuenow', data.percentage)

      if (data.status === 'done') {
        this.cleanup()
        this.statusText.textContent = 'Upload completed successfully! Check the import files page for errors if any.'
        this.statusText.classList.add('text-success')
        setTimeout(() => {
          window.location.href = '/file_imports'
        }, 2000)
      } else if (data.status === 'completed' || data.percentage === 100) {
        this.cleanup()
        this.statusText.textContent = 'Upload completed successfully!'
        this.statusText.classList.add('text-success')
        setTimeout(() => {
          window.location.href = '/file_imports'
        }, 2000)
      }
    } catch (error) {
      console.error('Error checking progress:', error)
      // If there's an error, we might want to stop checking
      if (!this.element.isConnected) {
        this.cleanup()
      }
    }
  }
}
